import { render, staticRenderFns } from "./FiltersForm.vue?vue&type=template&id=124d81b1"
import script from "./FiltersForm.vue?vue&type=script&lang=ts"
export * from "./FiltersForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports